//components
import { Modal } from 'react-bootstrap'
import OutlinedButton from '../../../ui/OutlinedButton/OutlinedButton'

//utils
import { createStructuredSelector } from 'reselect'
import { push } from 'connected-react-router'
import { connect } from 'react-redux'

//constants
import { ROUTES } from '../../../module/constants'
import { IErrorModalProps } from './module/constants'

//messages
import { FormattedMessage } from 'react-intl'
import messages from './module/messages'

//style
import classes from './ErrorModal.module.scss'

const ErrorModal = (props: IErrorModalProps) => {
  const { hasError, errorCode = '404', errorText, unSetError } = props

  const unSetErrOnCLick = () => {
    if (unSetError) unSetError()
  }

  return (
    <>
      <Modal show={hasError} onHide={unSetError} size="lg" centered>
        <Modal.Header className={classes['header']}>
          <Modal.Title>
            <FormattedMessage {...messages.title} />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="column">
            <h1 className={`row ${classes['errorCode']}`}>
              {hasError?.status ? hasError?.status : errorCode}
            </h1>

            <div className={`row ${classes['errorText']}`}>
              {errorText ? (
                <div>{errorText}</div>
              ) : (
                <FormattedMessage {...messages.simpleErrorMessage} />
              )}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <OutlinedButton onClick={() => unSetErrOnCLick()}>
            <FormattedMessage {...messages.ctaGoBack} />
          </OutlinedButton>
        </Modal.Footer>
      </Modal>
    </>
  )
}

const mapStateToProps: any = () => createStructuredSelector({})

// const mapDispatchToProps: any = {
//   changeLocation: (url: string) => push(url),
// }

const withConnect: any = connect(mapStateToProps /*, mapDispatchToProps*/)

export default withConnect(ErrorModal)
